module.exports = __webpack_public_path__ + "static/media/info.5c6cf213.svg";